<template>
  <div class="row">
    <!-- Sección Principal -->
    <div class="col-12 col-lg-9 col-md-8 py-3">
      <div class="main-section">
        <div class="job-content">
          <div class="job-card">
            <div class="mb-3">
              <a class="local-back-btn" @click="goBack">Volver</a>
            </div>

            <div class="job-image job-image--mobile">
              <img :src="jobData.image" :alt="jobData.work_pos" />
            </div>

            <h1 class="job-title">{{ jobData.work_pos }}</h1>

            <div class="job-information">
              <span class="vacancies">{{ jobData.n_vacancy }} vacantes</span>
              <span class="location">
                <i class="bx bx-map-pin" aria-hidden="true"></i>
                {{ jobData.place }}
              </span>
              <div class="actions">
                <button
                  class="icon-btn"
                  type="button"
                  aria-label="Favorito"
                  @click="toggleFavorite"
                >
                  <i class="bx bx-heart"></i>
                </button>
                <button
                  class="icon-btn"
                  type="button"
                  aria-label="Compartir"
                  @click="shareJob"
                >
                  <i class="bx bx-share-alt"></i>
                </button>
                <button class="apply-btn" @click="applyToJob">Postular</button>
              </div>
            </div>

            <div class="section-title">Descripción</div>
            <div class="description-content" v-html="jobData.description"></div>
          </div>

          <div class="job-image">
            <img :src="jobData.image" :alt="jobData.work_pos" />
          </div>
        </div>

        <div class="description-section">
          <div class="row">
            <div class="col-12 col-md-6 px-4">
              <div class="section-title">Funciones</div>
              <div v-html="jobData.functions"></div>
            </div>
            <div class="col-12 col-md-6 px-4">
              <div class="section-title">Requisitos</div>
              <div v-html="jobData.requirements"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sidebar -->
    <div class="col-12 col-lg-3 col-md-4 py-3">
      <div class="sidebar">
        <h3 class="sidebar-title">Posiciones Similares</h3>

        <div v-for="job in similarJobs" :key="job.id" class="similar-job">
          <div class="similar-job-info">
            <div class="similar-job-title">{{ job.title }}</div>
            <div class="similar-job-location">
              <i class="bx bx-map-pin" aria-hidden="true"></i>{{ job.location }}
            </div>
          </div>
          <div class="similar-job-actions">
            <button
              class="icon-btn"
              type="button"
              aria-label="Compartir"
              @click="shareSimilarJob(job)"
            >
              <i class="bx bx-share-alt"></i>
            </button>
            <button
              class="icon-btn"
              type="button"
              aria-label="Ver detalle"
              @click="goToDetail(job)"
            >
              <i class="bx bx-link-external"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JobListingSection",
  props: {
    initialJobData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isUserLogged() {
      return !!localStorage.getItem("userData");
    },
  },
  data() {
    return {
      jobData: {
        work_pos: "Supervisor de Seguridad y Salud en el Trabajo",
        n_vacancy: 3,
        place: "Olmos",
        functions: [
          "Digitalizar avances diarios de los campos cosechados.",
          "Brindar soporte en la elaboración y seguimiento de indicadores.",
          "Supervisar el cumplimiento de protocolos de seguridad.",
          "Realizar inspecciones periódicas en las áreas de trabajo.",
          "Coordinar capacitaciones en seguridad laboral.",
        ],
        requirements: [
          "Educación mínima: Universitario",
          "1 año de experiencia",
          "Conocimientos en normativas de seguridad laboral",
          "Manejo de herramientas de gestión de calidad",
          "Capacidad de liderazgo y trabajo en equipo",
        ],
        description:
          "Únete a nuestro equipo como Supervisor de Seguridad y Salud en el Trabajo. Buscamos un profesional comprometido con la implementación y supervisión de protocolos de seguridad laboral, que contribuya al bienestar de nuestro equipo y al cumplimiento de normativas vigentes.",
        image: require("@/assets/talento_agv/img/ofertas_laborales/ofertas_laborales.svg"), //Actualmente este campo no lo trae
      },
      similarJobs: [
        {
          id: 1,
          title: "Auxiliar de Cosecha",
          location: "Olmos",
          isFavorite: true,
        },
        {
          id: 2,
          title: "Operador de Maquinaria",
          location: "Chiclayo",
          isFavorite: false,
        },
        {
          id: 3,
          title: "Técnico de Campo",
          location: "Lambayeque",
          isFavorite: false,
        },
      ],
    };
  },
  mounted() {
    if (Object.keys(this.initialJobData).length > 0) {
      this.jobData = { ...this.jobData, ...this.initialJobData };
    }
  },
  methods: {
    toggleFavorite() {
      console.log("Añadir a favoritos");
    },

    shareJob() {
      if (navigator.share) {
        navigator.share({
          title: this.jobData.work_pos,
          text: `Revisa esta oferta de trabajo: ${this.jobData.work_pos}`,
          url: window.location.href,
        });
      } else {
        navigator.clipboard.writeText(window.location.href);
        this.$toastr.success("Enlace copiado al portapapeles.", "Listo");
      }
    },

    applyToJob() {
      if (!this.isUserLogged) {
        this.$router.push("/login");
        return;
      }
      console.log("Postular al trabajo");
    },

    goBack() {
      this.$router.go(-1);
    },

    shareSimilarJob(job) {
      if (navigator.share) {
        navigator.share({
          title: job.work_pos,
          text: `Revisa esta oferta de trabajo: ${job.work_pos}`,
          url: `${window.location.origin}/job/${job.id}`,
        });
      } else {
        navigator.clipboard.writeText(
          `${window.location.origin}/job/${job.id}`
        );
        this.$toastr.success("Enlace copiado al portapapeles.", "Listo");
      }
    },

    goToDetail(job) {
      this.$router.push({
        path: "/detalle_oferta",
        query: { id: job.id },
      });
    },
  },
};
</script>
<style scoped>
.main-section {
  background: white;
  border-radius: 12px;
  border: 2px solid var(--bg-primary-as-light);
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.job-content {
  display: flex;
  padding: 25px;
}

.job-card {
  flex: 1;
  margin-right: 20px;
}

.local-back-btn {
  color: var(--bg-primary-as-light);
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: start;
  gap: 5px;
  cursor: pointer;
}

.local-back-btn:hover {
  text-decoration: underline;
}

.job-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.2;
}

.job-information {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 25px;
  flex-wrap: wrap;
}

.vacancies {
  color: #666;
  font-size: 14px;
}

.location {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #666;
  font-size: 14px;
}

.actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.icon-btn {
  border: 1px solid rgba(10, 30, 70, 0.12);
  background: #fff;
  width: 34px;
  height: 34px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.icon-btn i {
  font-size: 18px;
  color: var(--bg-primary-as-light);
}

.icon-btn:hover {
  background: rgba(25, 87, 209, 0.06);
  border-color: rgba(25, 87, 209, 0.35);
}

.apply-btn {
  margin-left: auto;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid var(--bg-primary-as-light);
  background: #fff;
  color: var(--bg-primary-as-light);
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.apply-btn:hover {
  background: var(--bg-primary-as-light);
  color: #fff;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  margin-top: 25px;
}

.section-title:first-of-type {
  margin-top: 0;
}

.function-list,
.requirements-list {
  list-style: none;
  padding: 0;
}

.function-list li,
.requirements-list li {
  margin-bottom: 8px;
  padding-left: 15px;
  position: relative;
  color: #555;
  line-height: 1.4;
}

.function-list li:before,
.requirements-list li:before {
  content: "•";
  position: absolute;
  left: 0;
  color: #4a90e2;
  font-weight: bold;
}

.job-image {
  width: 250px;
  text-align: center;
}
.job-image img {
  width: 100%;
  height: 240px;
  object-fit: cover;
  border-radius: 8px;
}

.job-image--mobile {
  display: none;
}

.description-section {
  padding: 20px 25px;
  border-top: 1px solid #eee;
}

.description-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.description-content {
  color: #666;
  line-height: 1.5;
}

/* Sidebar */
.sidebar {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: fit-content;
}

.sidebar-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.similar-job {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 10px;
  transition: border-color 0.2s;
  flex-wrap: wrap;
}
.similar-job:hover {
  border-color: var(--bg-primary-as-light);
}
.similar-job-info {
  flex: 1;
}
.similar-job-title {
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  font-size: 14px;
}
.similar-job-location {
  color: #666;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.similar-job-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-block: 10px;
}

/* Responsive */
@media (max-width: 768px) {
  .job-content {
    flex-direction: column;
  }

  .job-image {
    display: none;
  }
  .job-image--mobile {
    display: flex;
    justify-content: center;
    margin: 8px 0 16px;
    width: 100%;
  }
  .job-image--mobile img {
    width: min(240px, 70%);
    height: auto;
    aspect-ratio: 3 / 4;
    object-fit: cover;
    border-radius: 8px;
  }
}
</style>
